import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetStepsByStage as GetStepsByStageQuery,
    GetStepsByStage_lead_leadTasksBySource_steps as StepsByStage,
    GetStepsByStageVariables,
} from 'nutshell-graphql-types';

import GET_STEPS_BY_STAGE from '../queries/get-steps-by-stage.graphql';

export const useGetStepsByStage = (
    leadId: string
): {
    stepsByStage: StepsByStage[] | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetStepsByStageQuery,
        GetStepsByStageVariables
    >(GET_STEPS_BY_STAGE, {
        variables: {
            leadId,
        },
    });

    const stepsByStage =
        data && data.lead && data.lead.leadTasksBySource && data.lead.leadTasksBySource.steps;

    return {
        stepsByStage,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
